import React from 'react';
import ReactDOM from 'react-dom';
import './common/resetFontSize';
import App from './views/App';
import * as serviceWorker from './serviceWorker';
import './styles/index.css';

// import VConsole from 'vconsole';
// console.log('hello', new VConsole());

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
